import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Industries from "../pages/industries/page";
import Services from "../pages/services/page";
import WhyUs from "../pages/why-us/page";
import Team from "../pages/team/page";
import CSR from "../pages/csr/page";
import Apply from "../pages/apply/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/industries",
    element: <Industries />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/why-us",
    element: <WhyUs />,
  },
  {
    path: "/team",
    element: <Team />,
  },
  {
    path: "/csr",
    element: <CSR />,
  },
  {
    path: "/apply",
    element: <Apply />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;